/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SynergyIndexRouteImport } from './routes/synergy/index'
import { Route as StatisticsIndexRouteImport } from './routes/statistics/index'
import { Route as PlayerIndexRouteImport } from './routes/player/index'
import { Route as MatchIndexRouteImport } from './routes/match/index'
import { Route as PlayerPlayerIdRouteImport } from './routes/player/$playerId'
import { Route as GamesIdRouteImport } from './routes/games/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SynergyIndexRoute = SynergyIndexRouteImport.update({
  id: '/synergy/',
  path: '/synergy/',
  getParentRoute: () => rootRouteImport,
} as any)
const StatisticsIndexRoute = StatisticsIndexRouteImport.update({
  id: '/statistics/',
  path: '/statistics/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerIndexRoute = PlayerIndexRouteImport.update({
  id: '/player/',
  path: '/player/',
  getParentRoute: () => rootRouteImport,
} as any)
const MatchIndexRoute = MatchIndexRouteImport.update({
  id: '/match/',
  path: '/match/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerPlayerIdRoute = PlayerPlayerIdRouteImport.update({
  id: '/player/$playerId',
  path: '/player/$playerId',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdRoute = GamesIdRouteImport.update({
  id: '/games/$id',
  path: '/games/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/games/$id': typeof GamesIdRoute
  '/player/$playerId': typeof PlayerPlayerIdRoute
  '/match': typeof MatchIndexRoute
  '/player': typeof PlayerIndexRoute
  '/statistics': typeof StatisticsIndexRoute
  '/synergy': typeof SynergyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/games/$id': typeof GamesIdRoute
  '/player/$playerId': typeof PlayerPlayerIdRoute
  '/match': typeof MatchIndexRoute
  '/player': typeof PlayerIndexRoute
  '/statistics': typeof StatisticsIndexRoute
  '/synergy': typeof SynergyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/games/$id': typeof GamesIdRoute
  '/player/$playerId': typeof PlayerPlayerIdRoute
  '/match/': typeof MatchIndexRoute
  '/player/': typeof PlayerIndexRoute
  '/statistics/': typeof StatisticsIndexRoute
  '/synergy/': typeof SynergyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/games/$id'
    | '/player/$playerId'
    | '/match'
    | '/player'
    | '/statistics'
    | '/synergy'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/games/$id'
    | '/player/$playerId'
    | '/match'
    | '/player'
    | '/statistics'
    | '/synergy'
  id:
    | '__root__'
    | '/'
    | '/games/$id'
    | '/player/$playerId'
    | '/match/'
    | '/player/'
    | '/statistics/'
    | '/synergy/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GamesIdRoute: typeof GamesIdRoute
  PlayerPlayerIdRoute: typeof PlayerPlayerIdRoute
  MatchIndexRoute: typeof MatchIndexRoute
  PlayerIndexRoute: typeof PlayerIndexRoute
  StatisticsIndexRoute: typeof StatisticsIndexRoute
  SynergyIndexRoute: typeof SynergyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/synergy/': {
      id: '/synergy/'
      path: '/synergy'
      fullPath: '/synergy'
      preLoaderRoute: typeof SynergyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/statistics/': {
      id: '/statistics/'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof StatisticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/player/': {
      id: '/player/'
      path: '/player'
      fullPath: '/player'
      preLoaderRoute: typeof PlayerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/match/': {
      id: '/match/'
      path: '/match'
      fullPath: '/match'
      preLoaderRoute: typeof MatchIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/player/$playerId': {
      id: '/player/$playerId'
      path: '/player/$playerId'
      fullPath: '/player/$playerId'
      preLoaderRoute: typeof PlayerPlayerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id': {
      id: '/games/$id'
      path: '/games/$id'
      fullPath: '/games/$id'
      preLoaderRoute: typeof GamesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GamesIdRoute: GamesIdRoute,
  PlayerPlayerIdRoute: PlayerPlayerIdRoute,
  MatchIndexRoute: MatchIndexRoute,
  PlayerIndexRoute: PlayerIndexRoute,
  StatisticsIndexRoute: StatisticsIndexRoute,
  SynergyIndexRoute: SynergyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
